import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { ProficiencyRating, SkillDetailsStatus } from '@core/positions-and-skills-types';
import {
  AvatarComponent,
  BoxComponent,
  DividerComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

import { JobSkillScaleRatingComponent } from '../job-skill-scale-rating/job-skill-scale-rating.component';

@Component({
  selector: 'rt-job-skill-ratings',
  templateUrl: './job-skill-ratings.component.html',
  styleUrls: ['./job-skill-ratings.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RtTooltip,
    BoxComponent,
    AvatarComponent,
    DividerComponent,
    JobSkillScaleRatingComponent,
  ],
})
export class JobSkillRatingsComponent {
  public readonly skillRatings = input.required<ProficiencyRating[]>();
  public readonly status = input.required<SkillDetailsStatus>();
}
